import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-confirm-drop',
  templateUrl: './confirm-drop.component.html',
  styleUrls: ['./confirm-drop.component.scss']
})
export class ConfirmDropComponent implements OnInit {
  player: any;
  movePlayer: any;
  playerURL = `${environment.assetURL}/assets/uploads/players/`;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ConfirmDropComponent>) { }

  ngOnInit() {
    this.player = this.data.player;
    this.movePlayer = this.data.movePlayer;
    console.log(this.player, this.movePlayer);
  }

}
